import { render, staticRenderFns } from "./layoutFrameless.vue?vue&type=template&id=2c208d52&scoped=true&"
import script from "./layoutFrameless.vue?vue&type=script&lang=js&"
export * from "./layoutFrameless.vue?vue&type=script&lang=js&"
import style0 from "./layoutFrameless.vue?vue&type=style&index=0&id=2c208d52&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c208d52",
  null
  
)

export default component.exports